<template>
  <div class="modal-container help-dialog">
    <div class="modal-body">
      <h1>{{ $t('HELP.HEADING') }}</h1>
      <div v-if="userId">
        <p class="id-explanation">{{ $t('HELP.ID_EXPLANATION') }}</p>
        <div class="copy-wrapper">
          <Copyable id="helpdialog-pid" :content="userId" inline>
            <p class="userid">
              {{ $t('DASHBOARD.USER_ID') }}:
              <strong>{{ userId }}</strong>
            </p>
          </Copyable>
        </div>
      </div>
      <div class="choices">
        <a :href="mailTo" class="mail">
          <img src="/images/mail.svg" />
          <div class="mails">
            <h3>
              {{ mail }}
            </h3>
          </div>
          <p>{{ $t('HELP_PANEL.EMAIL_ANSWER_DURATION') }}</p>
        </a>
        <a :href="contactForm" target="_blank" class="customer-service">
          <img src="/images/customer-service.svg" />
          <h3>{{ $t('HELP.CONTACT_FORM.HEADING') }}</h3>
          <p>{{ $t('HELP.CONTACT_FORM.EXPLANATION') }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import contactData from 'commons/contactData/contactData';
import Copyable from 'commons/copyable/Copyable.vue';

export default {
  name: 'HelpDialog',
  components: {
    Copyable,
  },
  props: ['modalInstance', 'data'],
  computed: {
    ...mapState({
      userId: (s) => s.user.data.id,
    }),
    ...mapGetters({
      partnerType: 'user/partnerType',
    }),
    mail() {
      return contactData.getBestMailForPartnerType(this.partnerType);
    },
    mailTo() {
      return `mailTo:${this.mail}?subject=(Spread-ID ${this.userId})`;
    },
    contactForm() {
      return contactData.getBestContactFormForPartnerType(this.partnerType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';

h1,
h3 {
  margin: 0;
}

.copy-wrapper {
  display: flex;
}

.userid {
  margin: 0;
}

.id-explanation {
  display: block;
  color: $grey60;
  margin: 16px 0 8px 0;
}

img {
  width: 120px;
  margin-bottom: 16px;
}

.choices {
  margin-top: 24px;
  display: flex;

  & > a {
    width: 50%;
    min-width: 350px;
    background-color: $grey5;
    padding: 24px;
    border-radius: $border-radius-medium;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:first-child {
      margin-right: 8px;
    }

    &:last-child {
      margin-left: 8px;
    }

    p {
      margin: 16px 0 0 0;
      color: $grey60;
      text-align: center;
    }

    &:hover {
      box-shadow: inset 0 0 0 1px $pa-color-main;
    }
  }

  .mails {
    a {
      color: $grey80;
    }

    h3:nth-child(2) {
      margin-top: 12px;
    }
  }
}
</style>
